import home1 from "../../assets/img/IMG-20251110-WA0034.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function Hardscape() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h6>Building the Foundation of Beautiful Outdoor Spaces</h6>
                <h3>About Hardscape</h3>
                <p>
                  Hardscape is the foundation of every outdoor space — the paths
                  we walk on, the patios where we sit, the walls that hold the
                  garden together. It’s the part of landscape design that gives
                  structure and shape to nature.
                </p>
                <p>
                  A good hardscape doesn’t overpower the greenery — it supports
                  it. Stone, brick, wood, and concrete come together to form a
                  quiet balance between the natural and the built world. The
                  beauty lies in the details — the texture of a hand-cut stone,
                  the way light hits a pathway in the evening, or how rainwater
                  gently flows between tiles into the soil.
                </p>
                <p>
                  Authentic hardscape design is not just about materials; it’s
                  about intention. It’s about creating spaces that last, that
                  feel grounded and natural. Whether it’s a simple sitting area
                  under a tree, a rustic stone wall, or a modern outdoor deck,
                  the design should feel like it belongs — not forced, not
                  overdone.
                </p>
                <p>
                  True hardscape work respects the land. It considers drainage,
                  soil, and sustainability. It uses what fits the place — local
                  stone, natural colors, and forms that blend with the landscape
                  rather than fight against it.
                </p>
                <p>
                  In the end, hardscape is what gives strength and permanence to
                  an outdoor space. It’s the quiet backdrop that lets nature
                  shine, and the structure that helps a garden feel whole.
                </p>
              </div>
              <div className="fisherman-content">
                <h4>🎨 Hardscape Materials</h4>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Material</th>
                      <th>Common Uses</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Natural Stone</td>
                      <td>Walkways, patios, retaining walls</td>
                    </tr>
                    <tr>
                      <td>Brick</td>
                      <td>Paths, borders, fireplaces</td>
                    </tr>
                    <tr>
                      <td>Concrete</td>
                      <td>Driveways, slabs, modern patios</td>
                    </tr>
                    <tr>
                      <td>Wood</td>
                      <td>Decks, pergolas, fences</td>
                    </tr>
                    <tr>
                      <td>Gravel</td>
                      <td>Pathways, drainage zones</td>
                    </tr>
                    <tr>
                      <td>Pavers</td>
                      <td>Patios, walkways, pool decks</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cta">
                <h4>📞 Ready to Build With Stone, Wood, or Concrete?</h4>
                <p>
                  Let’s create something that lasts. From backyard makeovers to
                  large commercial installations, our hardscape experts will
                  help you design and build outdoor features that are both
                  functional and stunning.
                </p>
                <a href="mailto:info@example.com" className="commonButton">
                  📧 Contact Us Today
                </a>
              </div>

              <div className="fisherman-content d-none">
                <h4>🛠️ What Is Hardscaping?</h4>
                <p>
                  Hardscape refers to the non-living, structural elements of
                  landscape design. It includes everything from{" "}
                  <strong>paths, patios, and retaining walls</strong> to{" "}
                  <strong>
                    pergolas, decks, driveways, and stone features
                  </strong>
                  . Hardscaping plays a crucial role in both the{" "}
                  <strong>functionality</strong> and <strong>aesthetics</strong>{" "}
                  of an outdoor space.
                </p>
                <p>Examples include:</p>
                <ul>
                  <li>Stone walkways</li>
                  <li>Brick or concrete patios</li>
                  <li>Wooden decks</li>
                  <li>Retaining walls</li>
                  <li>Driveways &amp; paving</li>
                  <li>Fire pits and outdoor kitchens</li>
                  <li>Water features like fountains or ponds</li>
                </ul>
              </div>
              <div className="fisherman-content d-none">
                <h4>🔑 Benefits of Hardscape</h4>
                <ul>
                  <li>
                    <strong>Low Maintenance</strong> – No mowing or watering
                    required
                  </li>
                  <li>
                    <strong>Increased Usability</strong> – Creates livable
                    outdoor spaces
                  </li>
                  <li>
                    <strong>Adds Value</strong> – Enhances property value and
                    curb appeal
                  </li>
                  <li>
                    <strong>Erosion Control</strong> – Retaining walls help
                    prevent soil loss
                  </li>
                  <li>
                    <strong>All-Weather Durability</strong> – Works year-round,
                    in any climate
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="fisherman-content d-none">
            <h4>💡 Hardscape Design Tips</h4>
            <ul>
              <li>Balance hardscape and softscape for visual harmony.</li>
              <li>Use curves and varied textures to soften rigid lines.</li>
              <li>
                Combine materials (e.g., stone + wood) for a dynamic look.
              </li>
              <li>Prioritize drainage to prevent water pooling or erosion.</li>
              <li>
                Light it up! Add landscape lighting to highlight features.
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🧩 How Hardscape Fits into Landscape Design</h4>
            <p>
              Hardscape is one of the <strong>foundational layers</strong> of
              any landscape. It supports plant life (softscape), provides
              circulation (paths), zones for activity (patios, fire pits), and
              crucial structure (walls, steps).
            </p>
            <p>
              When well-designed, hardscape creates{" "}
              <strong>flow, function, and beauty</strong> — giving people a
              reason to be outside and enjoy their environment.
            </p>
          </div>
          <div className="fisherman-content d-none">
            <h4>🛠️ Our Hardscape Services May Include:</h4>
            <ul>
              <li>Custom patio design &amp; installation</li>
              <li>Walkways and stepping stones</li>
              <li>Retaining wall construction</li>
              <li>Outdoor kitchens and fire pits</li>
              <li>Pergolas, gazebos, and seating walls</li>
              <li>Driveway paving and resurfacing</li>
              <li>Drainage and grading solutions</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hardscape;
